var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAvatar = function SvgIconAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.667 28.333h-2.666v-2.666a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2.666H.334v-2.666A6.667 6.667 0 0 1 7.001 19h8a6.667 6.667 0 0 1 6.666 6.667zm-10.666-12a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-2.666A5.333 5.333 0 1 0 11 3a5.333 5.333 0 0 0 0 10.667"
  })));
};
export default SvgIconAvatar;